<template lang="html">
  <div class="">
    <div class="row w-full">
      <div class="col-md-4">
        <span class="span-placeholder">Costos actual de vivienda</span>
        <div class="inputwrapper" data-required="MXM">
        <input id="demoTextBox"  class="inputDataText" placeholder="$X,XXX,XXX.XX" v-model="valores.valor" name="username" @change="updateValores()" v-on:keypress="isNumber($event)"/>
        </div>
      </div>
      <div class="col-md-4">
        <span class="span-placeholder">Restante por pagar</span>
        <div class="inputwrapper" data-required="MXM">      
        <input id="demoTextBox"  class="inputDataText" placeholder="$X,XXX,XXX.XX" v-model="valores.credito" name="credito" @change="updateValores()" v-on:keypress="isNumber($event)"/>
        </div>
        <span class="text-danger span-placeholder" v-show="validacion">Debe ser menor al valor de la propiedad</span>
      </div>
     <div class="col-md-4" v-if=" destino == 25">
        <div class="label-switch">
          <span>Monto de Liquidez</span>
          <vs-switch v-model="valores.switchLiquidez"  @input="updateValores(); buscaBancos()"/>
        </div>
        <div class="inputwrapper" data-required="MXM" v-if="valores.switchLiquidez">
          <input
            id="demoTextBox"
            class="inputDataText"
            placeholder="$X,XXX,XXX.XX"
            v-model="valores.montoLiquidez"
            name="credito"
             v-on:keypress="isNumber($event)"
             @change="updateValores();"
          />
          <!--<input
            class="inputDataText"
            v-model="valores.montoLiquidez"
            @input="formateaMontoLiquidez"
            placeholder="$0.00"
            @change="updateValores(); formateaMontoLiquidez();"
            v-on:keypress="isNumber($event)"
          />-->
        </div>
      </div>
       <div class="col-md-4" v-if=" programa == 6">
        <span class="span-placeholder">Salario integrado</span>
        <div class="alinear" >
        <input id="demoTextBox"  class="inputDataText" placeholder="$X,XXX,XXX.XX" v-validate="'max:13'" label="Salario integrado" v-model="valores.salarioIntegrado" name="aportacion" @change="updateValores(); formateaAportacion(); "  v-on:keypress="isNumber($event)"/>
        <!--<span class="text-danger span-placeholder" v-show="errors.has('credito')">Máximo son 10 digitos</span>-->
        </div>          
        <!--<span 
          class="text-danger span-placeholder d-block" 
          v-if="isDecimalM">Se recomienda trabajar números enteros.</span>-->
      </div>
    </div>
    <div class="row w-full">
      <div class="col-md-4">
        <span class="span-placeholder">Pago mensual</span>
        <div class="inputwrapper" data-required="MXM">        
        <input id="demoTextBox"  class="inputDataText" placeholder="$X,XXX,XXX.XX" v-model="valores.mensualidad" name="username" @change="updateValores()" v-on:keypress="isNumber($event)"/>
        </div>
      </div>
      <div class="col-md-4">
        <span class="span-placeholder" for="plazos">Tiempo restante crédito</span>
        <select name="cars" id="plazos" v-model="valores.plazoRestante" class="vs-input" style="border: 1px solid rgba(0, 0, 0, 0.2);" @change="updateValores()">
          <option value="" disabled>Selecciona una opción</option>
          <option :value='tipo.value' v-for="tipo in plazos" >{{tipo.label}}</option>
        </select>
      </div>
    </div> 
    <div class="row w-full">        
      <div class="col-md-4">
        <span class="span-placeholder">Plazos a cotizar</span>
        <v-select v-model="valores.plazosACotizar" multiple :closeOnSelect="false" :options="plazos" :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="updateValores(), buscaBancos()"/>
      </div>
      <div class="col-md-4">
        <span class="span-placeholder">Esquemas de pago</span>

        <v-select v-model="valores.esquemasACotizar" multiple :closeOnSelect="false" :options="esquemas" :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="updateValores(), buscaBancos()"/>
      </div>
      <!--<div class="vx-col lg:w-1/4 sm:w-full">
        <span class="span-placeholder">Gastos notariales</span>
        <select name="gastosNotariales" id="gastosNotariales" v-model="valores.gastosNotarial" class="v-select vs--single  vs-input--input" @change="updateValores()">
              <option :value='tipo.value' v-for="tipo in gastosNotariales"  :key="">{{tipo.label}}</option>
        </select>
      </div>-->
    </div>
    <input class="vs-input" hidden   v-model="otro" name="otro" @change="updateValores()" />
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
  },
  props: {
    otro: {
      type: Number,
      required: false
    },
    programa:{
      type: Number,
      required: false
    },
    salarioIntegrado:{
      type: Number,
      required: false
    },destino: {
      type: Number,
      required: false
    },
    montoLiquidez:{
      type: String,
      required: false
    }
   }, 
  data(){
		return{
      plazos:[
        { label: '30 Años',  value: '30' },
        { label: '29 Años',  value: '29' },
        { label: '28 Años',  value: '28' },
        { label: '27 Años',  value: '27' },
        { label: '26 Años',  value: '26' },
        { label: '25 Años',  value: '25' },
        { label: '24 Años',  value: '24' },
        { label: '23 Años',  value: '23' },
        { label: '22 Años',  value: '22' },
        { label: '21 Años',  value: '21' },
        { label: '20 Años',  value: '20' },
        { label: '19 Años',  value: '19' },
        { label: '18 Años',  value: '18' },
        { label: '17 Años',  value: '17' },
        { label: '16 Años',  value: '16' },
        { label: '15 Años',  value: '15' },
        { label: '14 Años',  value: '14' },
        { label: '13 Años',  value: '13' },
        { label: '12 Años',  value: '12' },
        { label: '11 Años',  value: '11' },
        { label: '10 Años',  value: '10' },
        { label: '9 Años',  value: '9' },
        { label: '8 Años',  value: '8' },
        { label: '7 Años',  value: '7' },
        { label: '6 Años',  value: '6' },
        { label: '5 Años',  value: '5' },
        { label: '4 Años',  value: '4' },
        { label: '3 Años',  value: '3' },
        { label: '2 Años',  value: '2' },
        { label: '1 Años',  value: '1' },
      ],
      esquemas:[
        { label: 'Pago Fijo',  value: '2' },
        { label: 'Pago creciente',  value: '1' },
      ],
      id:'',
      gastosNotariales:[{label : '1 %', value : '1'},
                        {label : '2 %', value : '2'},
                        {label : '3 %', value : '3'},
                        {label : '4 %', value : '4'},
                        {label : '5 %', value : '5'},
                        {label : '6 %', value : '6'},
                        {label : '7 %', value : '7'},
                        {label : '8 %', value : '8'},
                        {label : '9 %', value : '9'},
                        {label : '10 %', value : '10'}
      ],
      valores:{
        destino:19,
        valor:'',
        credito:'',
        mensualidad:'',
        plazoRestante:'',
        esquemasACotizar:[{ label: 'Pago Fijo',  value: '2' }],
        plazosACotizar:[{ label: '10 Años',  value: '10' },{ label: '15 Años',  value: '15' },{ label: '20 Años',  value: '20' }],
        gastosNotarial:6,
        otro:0,
        salarioIntegrado:0.0,
        montoLiquidez:'',
        switchLiquidez:false
      },
      auxIngreso:false
    }
  },
  mounted(){
    this.id=this.$route.params.id
    this.getApikey()
    if(this.id)this.dameCaso()

    if(this.$route.path == '/nuevaCotizacion' && localStorage.getItem('caso')){
      this.id=localStorage.getItem('caso')
      this.dameCaso()
    }
    this.auxIngreso = true
  },
  watch: {
    programa:function(){
      if(this.id > 0 ){
      let salarioIntegradoaux = 0
			if(this.valores.salarioIntegrado != '0'){
				let salarioStr = this.valores.salarioIntegrado;
				salarioIntegradoaux =  Number(salarioStr.replace(/[$,]/g, ''));
			}
      if((this.programa == 4 || this.programa == 6) && salarioIntegradoaux <= 0){
              //this.valores.salarioIntegrado = this.salarioIntegrado
              	// Formatea como moneda
						this.valores.salarioIntegrado = new Intl.NumberFormat('es-MX', {
							style: 'currency',
							currency: 'MXN',
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						}).format(this.salarioIntegrado);
      }
      this.updateValores()
      }
    },
    mensualidad: function(newValue) {
      this.valores.mensualidad= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    valor: function(newValue) {
      this.valores.valor= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    credito: function(newValue) {
      this.valores.credito= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    montoLiquidez: function(newValue) {
      this.valores.montoLiquidez= newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    otro:function(){
      if(this.otro > 0){
        this.updateValores()
      }
    }
  },
  computed:{
    validacion() {
      return this.valores.credito.replace(/,/g,"") > this.valores.valor.replace(/,/g,"")*1
    },
    valor(){
      return this.valores.valor
    },
    credito(){
      return this.valores.credito
    },
    mensualidad(){
      return this.valores.mensualidad
    },
    montoLiquidez(){
      return this.valores.montoLiquidez
    }
  },
  methods:{
     formateaMontoLiquidez() {
    let valor = this.valores.montoLiquidez;

    // quitar todo lo que no sea número o punto
    valor = valor.replace(/[^0-9.]/g, "");

    // convertir a número
    const numero = parseFloat(valor);

    if (!isNaN(numero)) {
      this.valores.montoLiquidez = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2
      }).format(numero);
    } else {
      this.valores.montoLiquidez = "";
    }
  },
    formateaAportacion(){ 
      let salarioStr = this.valores.salarioIntegrado;

      // Paso 1: Limpia el formato (quita $ y comas)
      let salario = Number(salarioStr.replace(/[$,]/g, ''));
      
      if(salario == 0){
        let salarioIntegradoaux = 0
        if((this.programa == 4 || this.programa == 6) && salario == 0){
                //this.valores.salarioIntegrado = this.salarioIntegrado
                  // Formatea como moneda

              salario = this.salarioIntegrado;
        }
      }
      // Redondea a 2 decimales si es necesario
      salario = parseFloat(salario.toFixed(2));

      // Formatea como moneda
      this.valores.salarioIntegrado = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(salario);
      this.updateValores()
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    updateValores(){
      this.valores.otro=this.otro
      if(this.destino==25){
        this.valores.destino= this.destino
      }else{
        this.valores.destino= 19
      }
      // Limpiar formato de montoLiquidez antes de enviar
      let valoresLimpios = { ...this.valores }
      if (valoresLimpios.montoLiquidez && valoresLimpios.montoLiquidez !== '') {
        valoresLimpios.montoLiquidez = parseFloat(valoresLimpios.montoLiquidez.replace(/,/g, ''))
      } else {
        valoresLimpios.montoLiquidez = 0
      }
      this.$emit('updateValores', valoresLimpios)
    },
     buscaBancos(){
      this.valores.otro=this.otro
      // Limpiar formato de montoLiquidez antes de enviar
      let valoresLimpios = { ...this.valores }
      if (valoresLimpios.montoLiquidez && valoresLimpios.montoLiquidez !== '') {
        valoresLimpios.montoLiquidez = parseFloat(valoresLimpios.montoLiquidez.replace(/,/g, ''))
      } else {
        valoresLimpios.montoLiquidez = 0
      }
      this.$emit('buscaBancos', valoresLimpios)
    },
    dameCaso(){
      let self= this
      var objRequestDameCaso = {
        strApiKey: this.key,
        strMetodo: 'DameCaso',
        objCaso: {
         Id: this.id
        }
      }
      this.$axios.post('/',objRequestDameCaso,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
          if(response.data.intEstatus == 0){
            let cotizacion=response.data.objContenido;
            this.valores.plazosACotizar=[]
            this.valores.esquemasACotizar=[]
            this.valores.valor=(cotizacion.ValorInmueble).toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.valores.credito=(cotizacion.MontoSolicitado).toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.valores.plazoRestante=cotizacion.PlazoRestante
            if (cotizacion.PagoMensualActual) {
              this.valores.mensualidad= (cotizacion.PagoMensualActual).toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            for (var i = 0; i < cotizacion.Plazos.length; i++) {
              this.valores.plazosACotizar.push(cotizacion.Plazos[i]+' Años')
            }
            for (var i = 0; i < cotizacion.Esquemas.length; i++) {
              if (cotizacion.Esquemas[i] == 2) {
                this.valores.esquemasACotizar.push({ label: 'Pago Fijo',  value: '2' })
              }  else if (cotizacion.Esquemas[i] == 1) {
                this.valores.esquemasACotizar.push({ label: 'Pago creciente',  value: '1' })
              }
            }
             /**Mejora aprtaciones patronales 22-10-2025* */
            //22-10-2025  Mejora aportaciones patronales
            let salario = cotizacion.MontoSalarioIntegrado ;
            if((this.programa == 4 || this.programa == 6) && cotizacion.MontoSalarioIntegrado  ==0){ 
              salario = this.salarioIntegrado
            }
						// Paso 1: Limpia el formato (quita $ y comas)
						//let salario = Number(salarioStr.replace(/[$,]/g, ''));
						// Redondea a 2 decimales si es necesario
						salario = parseFloat(salario.toFixed(2));

						// Formatea como moneda
						this.valores.salarioIntegrado = new Intl.NumberFormat('es-MX', {
							style: 'currency',
							currency: 'MXN',
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						}).format(salario);
            /*****Mejoramonto liquidez acg */
						this.valores.montoLiquidez = cotizacion.MontoLiquidez ? cotizacion.MontoLiquidez.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''
            this.valores.switchLiquidez = Boolean(cotizacion.TieneMontoLiquidez)
            
            this.valores.destino=cotizacion.destino; 
            //this.destino = cotizacion.Destino
            this.updateValores()
           // alert(Boolean(cotizacion.TieneMontoLiquidez)+'--'+this.auxIngreso)
            if(!Boolean(cotizacion.TieneMontoLiquidez) && this.auxIngreso){
              this.buscaBancos();
            }
          }else {
            this.$vs.notify({
              title:'Ocurrio un error en DameCaso',
              text:response.data.strError,
              color:'danger',
              position:'top-right'
            })
          }
        }
      ).catch(function (error) {
        self.$vs.notify({
          title:'Ocurrio un error de sistema',
          text:error,
          color:'danger',
          position:'top-right'
        })
      })
    },
    getApikey(){
      if(!JSON.parse(localStorage.getItem('userInfo')).ApiKey){
        this.$router.push('/login');
      }else {
        this.key=JSON.parse(localStorage.getItem('userInfo')).ApiKey;
      }
    }
  }
}
</script>

<style lang="css" scoped>
.v-select{
    width: 100%;
}
.label-select{
  margin-top: 3%;
}
.label-switch {
  display: flex;
  align-items: center;
  gap: 8px; /* espacio entre texto y switch */
  
}
</style>